export default "https://cdn-static.gokick.com/assets/3cd141d05df56e6b81a0153ff619f4101846aa93/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";